'use client'

import { Tabs } from '@/components/ui/tabs'
import { scrollToProductSection } from '@/lib/utils/scroll-utils'
import { TFacet, TFacetValue } from '@/types/collection'
import { useShallow } from 'zustand/react/shallow'
import { useCollectionFilterStoreV2 } from '../../../store/collection-filter-store-v2'

type Props = {
  // Pass facet directly for better performance and decoupling
  facet?: TFacet
  optionsCustom?: {
    label: string
    value: string
  }[]
  // Custom filter key when using optionsCustom
  filterKey?: string
}

export const FilterTabs = ({ facet, optionsCustom, filterKey }: Props) => {
  const { filters, setFilter } = useCollectionFilterStoreV2(
    useShallow((state) => ({
      filters: state.filters,
      setFilter: state.setFilter,
    }))
  )

  // Use facet from props directly
  const targetFacet = facet

  if (!targetFacet && !optionsCustom) {
    return null
  }

  const options =
    optionsCustom ||
    targetFacet?.facet_values?.map((item: TFacetValue) => ({
      label: item.title,
      value: item.seo_alias,
    })) ||
    []

  const filterTabs = [
    {
      label: 'Tất cả',
      value: 'all',
    },
    ...options,
  ]

  // Use filterKey prop or fallback to facet's seo_alias
  const seoAlias = filterKey || targetFacet?.seo_alias || ''

  const onChangeTab = (value: string) => {
    if (value === 'all') {
      setFilter(seoAlias, undefined)
    } else {
      setFilter(seoAlias, value)
    }

    // Cuộn lên đầu danh sách sản phẩm sau khi thay đổi filter tab
    scrollToProductSection(200, 50)
  }

  return (
    <Tabs
      options={filterTabs}
      variant='filter'
      wrapperClassName='gap-2'
      onChange={onChangeTab}
      defaultValue={(filters[seoAlias] as string) || 'all'}
      triggerClassName='lg:h-10.5 lg:px-6 lg:py-2 lg:text-base lg:leading-6.5'
      size='small'
    />
  )
}
